import { render, staticRenderFns } from "./AddPriceForm.vue?vue&type=template&id=267efedc&"
import script from "./AddPriceForm.vue?vue&type=script&lang=js&"
export * from "./AddPriceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports